/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_ResumeInputs */

const en_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume data:`)
};

const de_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslaufdaten:`)
};

const fr_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de CV :`)
};

const es_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de currículum:`)
};

const it_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati del curriculum:`)
};

const nl_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-gegevens:`)
};

const pl_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane CV:`)
};

const fi_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelotiedot:`)
};

const da_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-data:`)
};

const sv_privacy_data_processing_item_resume = /** @type {(inputs: Privacy_Data_Processing_Item_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-data:`)
};

/**
* | output |
* | --- |
* | "Resume data:" |
*
* @param {Privacy_Data_Processing_Item_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_resume = /** @type {((inputs?: Privacy_Data_Processing_Item_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_resume(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_resume(inputs)
	if (locale === "es") return es_privacy_data_processing_item_resume(inputs)
	if (locale === "it") return it_privacy_data_processing_item_resume(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_resume(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_resume(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_resume(inputs)
	if (locale === "da") return da_privacy_data_processing_item_resume(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_resume(inputs)
	return en_privacy_data_processing_item_resume(inputs)
});